// @ts-nocheck





import { fetchRequest, initialFetchListParams } from './index';


import { convertFromRubToKop, convertFromKopToRub } from '../pure/unitConversions';

export const convertDataToServer = (incomeSchedule) => ({
  ...incomeSchedule,
  sum: convertFromRubToKop(incomeSchedule.sum),
  sumWithTax: convertFromRubToKop(incomeSchedule.sumWithTax)
});
export const convertDataFromServer = (incomeSchedule) => ({
  ...incomeSchedule,
  sum: convertFromKopToRub(incomeSchedule.sum),
  sumWithTax: convertFromKopToRub(incomeSchedule.sumWithTax)
});

export const addIncomeSchedule = async (
incomeSchedule) =>
{
  const added = await fetchRequest.post(
    '/incomeSchedule',
    convertDataToServer(incomeSchedule)
  );
  if (added) return convertDataFromServer(added);
  throw new Error('Не удалось создать график поступления');
};

export const updateIncomeSchedule = async (
incomeSchedule) =>
{
  const updated = await fetchRequest.put(
    '/incomeSchedule',
    convertDataToServer(incomeSchedule)
  );
  if (updated) return convertDataFromServer(updated);
  throw new Error('Не удалось обновить график поступления');
};

export const fetchIncomeSchedule = async (
params = initialFetchListParams) =>
{
  const incomeShedules = await fetchRequest.get('/incomeSchedule', {
    ...initialFetchListParams,
    ...params
  });
  if (incomeShedules) {
    return {
      ...incomeShedules,
      data: incomeShedules.data.map(convertDataFromServer)
    };
  }
  throw new Error('Не удалось загрузить спиоск графиков поступлений');
};

export const getIncomeSchedule = async (
id,
params = {}) =>
{
  const offer = await fetchRequest.get(`/incomeSchedule/${id}`, params);
  if (offer) return convertDataFromServer(offer);
  throw new Error('Не удалось загрузить график поступлений');
};

export const deleteIncomeSchedule = async (
id) =>
{
  const deleted = await fetchRequest.delete(`/incomeSchedule/${id}`);
  if (deleted) return convertDataFromServer(deleted);
  throw new Error('Не удалось удалить график поступления');
};

export default {
  addIncomeSchedule,
  updateIncomeSchedule,
  fetchIncomeSchedule,
  deleteIncomeSchedule,
  getIncomeSchedule
};
